// src/detailPages/termsandcondition/TermsAndConditions.jsx

import React from "react";
import Footer from "../../components/Footer/Footer";

const TermsAndConditions = () => {
    return (
        <>
            <div className="container my-5">
                <div className="row justify-content-center">
                    <div className="col-lg-10">

                        <div className="bg-white shadow-sm rounded p-5">

                            {/* Title */}
                            <h1 className="text-center fw-bold mb-2">
                                Terms & Conditions
                            </h1>
                            <p className="text-center text-muted mb-4">
                                Effective Date: 27 February, 2026 | Last Updated: 27 February, 2026
                            </p>

                            <p>
                                Welcome to <strong>avnii.in</strong>. These Terms and Conditions
                                govern your use of our website and purchases made through it.
                                By accessing or placing an order, you agree to these Terms.
                            </p>

                            <hr className="my-4" />

                            {/* Section 1 */}
                            <h5 className="fw-bold">1. About Us</h5>
                            <p>
                                avnii.in is owned and operated by <strong>Swarna Prakash Jewellers</strong>,
                                Karnataka, India.
                            </p>
                            <ul>
                                <li>Email: swarnaprakashjewellers@gmail.com</li>
                                <li>Phone/WhatsApp: 7204429777</li>
                                <li>
                                    Address: Karla City Centre, Joduraste, Karkala, Karnataka
                                </li>
                            </ul>

                            <hr className="my-4" />

                            {/* Section 2 */}
                            <h5 className="fw-bold">2. Eligibility & User Accounts</h5>
                            <ul>
                                <li>You must be at least 18 years old.</li>
                                <li>Provide accurate and complete information.</li>
                                <li>You are responsible for your account activity.</li>
                            </ul>

                            <hr className="my-4" />

                            {/* Section 3 */}
                            <h5 className="fw-bold">3. Products & Silver Purity</h5>
                            <p>
                                All jewellery is made of <strong>BIS Hallmarked 925 Sterling Silver</strong>.
                                Slight variations may occur due to handcrafted finishing and screen settings.
                            </p>

                            <hr className="my-4" />

                            {/* Section 4 */}
                            <h5 className="fw-bold">4. Pricing & Payments</h5>
                            <ul>
                                <li>All prices are in INR and inclusive of GST.</li>
                                <li>Prepaid payments only.</li>
                                <li>No Cash on Delivery (COD).</li>
                                <li>Secure third-party payment gateways are used.</li>
                            </ul>

                            <hr className="my-4" />

                            {/* Section 5 */}
                            <h5 className="fw-bold">5. Shipping & Delivery</h5>
                            <ul>
                                <li>Shipping available within select locations in India.</li>
                                <li>Orders dispatched within 2–3 business days.</li>
                                <li>Delivery timelines are estimates.</li>
                            </ul>

                            <hr className="my-4" />

                            {/* Section 6 */}
                            <h5 className="fw-bold">6. Returns & Refunds</h5>
                            <p>
                                Returns are accepted only for damaged or defective products.
                            </p>

                            <h6 className="fw-bold mt-3">Mandatory Unboxing Video</h6>
                            <ul>
                                <li>Clear uninterrupted unboxing video required.</li>
                                <li>Must show sealed package before opening.</li>
                                <li>Request must be raised within 48 hours.</li>
                            </ul>

                            <hr className="my-4" />

                            {/* Section 7 */}
                            <h5 className="fw-bold">7. Silver Care & Tarnishing</h5>
                            <p>
                                Tarnishing is a natural property of silver and is not considered a defect.
                            </p>

                            <hr className="my-4" />

                            {/* Section 8 */}
                            <h5 className="fw-bold">8. Intellectual Property</h5>
                            <p>
                                All content on avnii.in is the exclusive property of the brand
                                and protected under Indian law.
                            </p>

                            <hr className="my-4" />

                            {/* Section 9 */}
                            <h5 className="fw-bold">9. Limitation of Liability</h5>
                            <p>
                                Our liability is limited to the amount paid for your order.
                            </p>

                            <hr className="my-4" />

                            {/* Section 10 */}
                            <h5 className="fw-bold">10. Governing Law</h5>
                            <p>
                                These Terms are governed by the laws of India. Jurisdiction:
                                Karnataka courts.
                            </p>

                            <hr className="my-4" />

                            {/* Section 11 */}
                            <h5 className="fw-bold">11. Contact Us</h5>
                            <p>
                                Email: swarnaprakashjewellers@gmail.com <br />
                                Phone: 7204429777
                            </p>

                            <div className="text-center text-muted mt-5 small">
                                © avnii.in | All Rights Reserved
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default TermsAndConditions;